import { memo } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import TransactionRow from './TransactionRow';
import { SectionWrapper } from '../../SectionWrapper';

const TransactionList = ({ transactions, maxTransaction }) => {
  const transactionsToDisplay = maxTransaction
    ? transactions.slice(0, maxTransaction)
    : transactions;
  return (
    <SectionWrapper
      gap="8px"
      height="100%"
    >
      <Text
        size="lg"
        weight="medium"
      >
        Transactions
      </Text>
      <Stack direction="column">
        {transactionsToDisplay.map(
          ({ id, createdAt, summary, direction, amount: { formattedAmount } }) => (
            <TransactionRow
              amount={formattedAmount}
              createdAt={createdAt}
              direction={direction}
              id={id}
              key={id}
              summary={summary}
            />
          )
        )}
      </Stack>
    </SectionWrapper>
  );
};

TransactionList.propTypes = {
  transactions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      direction: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      summary: PropTypes.string.isRequired,
      amount: PropTypes.shape({
        formattedAmount: PropTypes.string.isRequired
      })
    })
  ).isRequired,
  maxTransaction: PropTypes.number
};

export default memo(
  TransactionList,
  (prevProps, nextProps) =>
    prevProps.transactions === nextProps.transactions &&
    prevProps.maxTransaction === nextProps.maxTransaction
);
